import { TextField, ThemeProvider, createTheme, Button ,   CircularProgress,
} from "@mui/material";
import React, { useEffect, useState, useRef, useMemo } from "react";
import axios from "axios";
import { InputAdornment, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { Formik, useFormik } from "formik";
import * as yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../../components/Loader";
import Backdrop from "@mui/material/Backdrop";
import ChooseFileExample from "./ChooseFileExample";
// import { common_axios } from "../../..";
import { common_axios } from "../../../App";
import ColumnFilter from "../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import Autocomplete from "@mui/material/Autocomplete";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import RefreshIcon from "@mui/icons-material/Refresh";
import SettingsBackupRestoreRoundedIcon from "@mui/icons-material/SettingsBackupRestoreRounded";
import Blacklisting from "../../../../src/file/Blacklist.xlsx";
import Swal from "sweetalert2";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import Pagination from "@mui/material/Pagination";

import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import moment from "moment";
const BulkUpload = ({ resetValue }) => {
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
        },
      },
    },
  });
  const customId1 = "custom-id-yess";
  const [value, setValue] = React.useState(null);
// console.log("mmmm",value)
  const [file, setFile] = useState();
  const [hide, setHide] = useState(true);
  const [data, setData] = useState([]);
  const [open, setOpen] = useState();
  const [hideDownload, sethideDownload] = useState(true);
  const [downloaddata, setDownloaddata] = useState("");
  const [accountcountryid, setAccountCountryId] = useState("");
  const [accountidvalue, setAccountIdValue] = useState([]);
  const [userState, setUserState] = React.useState([]);
  const [hideSkeleton1, setHideSkeleton1] = useState();
  const [data1, setData1] = useState([]);
  const [TableStatus, setTableStatus] = useState({
    hideShow: false,
    pageNo: 0,
    pageSize: 10,
  });
  const [paginationPage, setPaginationPage] = React.useState(1);

  function handleChange(event) {
    setFile(event.target.files[0]);
    setHide(false);
  }
  // const fileext = file?.name?.split(".")[1];
  const uploadreset = () => {
    document.getElementById("fileName").value = "";
    setUserState([]);
    setHide(true);
    setValue(null)

  };
  // const fileext = file?.name;
  // const extesion = fileext?.substring(fileext.lastIndexOf(".") + 1);
  const fileext = file?.name;
  const extesion = fileext?.substring(fileext.lastIndexOf(".") + 1);
  async function SubmitImage(e) {
    let userIds = [];
    // for (let i = 0; i < userState.length; i++) {
    //   userIds[i] = userState[i].userId;
    // }
    for (let i = 0; i < userState.length; i++) {
      if (userState[i].userId != "all") {
        userIds[i] = userState[i].userId;
      }
    }
    if (extesion == "xlsx" || extesion == "csv" || extesion == "xls") {
      try {
        const formData = new FormData();
        // event.currentTarget.disabled = true; //to disable upload button after one click......
        const ids = userState?.map((ddd) => ddd.userId)?.toString();
        formData.append("dndExcel", file);
        formData.append("username", localStorage.getItem("usernamedisplayed"));
        formData.append("userId", JSON.parse(localStorage.getItem("Sidebaritems")).name ==
        "ROLE_SUPER_ADMIN"
          ? userIds?.length > 0
            ? userIds
            : ""
          : [JSON.parse(localStorage.getItem("items")).uid]);

    
        formData.append("flag", JSON.parse(localStorage.getItem("Sidebaritems")).name ==
        "ROLE_SUPER_ADMIN" ? userIds?.length > 0 ? false : true
        : false);
        formData.append("upto",moment(value)?.format(
          "YYYY-MM-DD HH:mm:ss"
        ))
        setOpen(true);
    
        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/dnd/v2/save/excel`,
          formData
        );
        if (res.data.statusDescription.statusCode == 200) {
          setHide(true);
          setOpen(false);
          setValue(null)

          sethideDownload(false);
          setUserState([]);
          // sethideBulkUpload(false);
          document.getElementById("fileName").value = "";

          BulkTableget();

          setTimeout(() => {
            BulkTableget();
          }, 30000);

          setDownloaddata(res.data.downloadUrl);
          Swal.fire({
            icon: "success",
            text: "File uploaded successfully!!",
          });
        } else {
          setOpen(false);
        
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.statusdescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } catch (error) {
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please Check Your Network",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } else {
      setHide(true);
      document.getElementById("fileName").value = "";
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Select Excel File",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }
  async function BulkTableget() {
    setData([])
    try {
      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/dnd/v2/get-all/uploaded/dnd/file`,

        {
          username: localStorage.getItem("usernamedisplayed"),
          uploadType: "DND",
          pageNo: TableStatus?.pageNo,
          pageSize: TableStatus?.pageSize,
        }
      );
      if (result.data.statusDescription.statusCode == 200) {
        await setData(result.data.fileUploads.content);
        await setData1(result.data.fileUploads);
      } else {
        setOpen(false);
        setData([])
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusdescription,
        });
      }
    } catch (error) {
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
      });
    }
  }

  // const downloadFile = (cell) => {
  //   window.location.href = cell.row.original.downloadUrl; //to download the file from url in download button
  // };
  const downloadFile = async (cell) => {
    // console.log(cell.row.original,"kkjhh")
    try {
      const response = await common_axios.get(
        `${cell?.row?.original?.downloadUrl}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            // UserId:`${localStorage.getItem('UserId')}`,
            // Source: "web",
          },
        }
      );
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/vnd.ms-excel" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `excel-file.xlsx`);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      // console.error(error);
    }
  };
  useEffect(async () => {
    BulkTableget();
  }, [TableStatus.pageSize, TableStatus.pageNo]);

  // ...............................Refresh BUTTON api ..................................//

  async function RefreshBtn() {
    setData([])
    try {
      setOpen(true);

      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/dnd/v2/get-all/uploaded/dnd/file`,
        {
          username: localStorage.getItem("usernamedisplayed"),
          uploadType: "DND",
          pageNo: TableStatus?.pageNo,
          pageSize: TableStatus?.pageSize,
        }
      );

      // console.log("result get api.........", result);

      if (result.data.statusDescription.statusCode == 200) {
        setOpen();
        await setData(result.data.fileUploads.content);
        await setData1(result.data.fileUploads);
      } else {
        setOpen();
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusdescription,
    
        });
      }
    } catch (error) {
      setOpen();

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }

  // ---------------------------------Table-------------------------------//

  const columns = useMemo(
    () =>  JSON.parse(localStorage.getItem("Sidebaritems")).name ==
    "ROLE_SUPER_ADMIN"
    ? [
      {
        Header: "Id",
        accessor: "id",
        Cell: (cell) =>  <>{cell.row.index + 1 + TableStatus?.pageNo * TableStatus?.pageSize}</>
      },
      // {
      //   Header: "Uploaded By",
      //   accessor: "uploadedBy",
      // },
      // {
      //   Header: "Filename",
      //   accessor: "filename",
      // },
      {
        Header: "Filename",

        accessor: "filename",
        Cell: (cell) => {
          return (
            <>
              <div
              
                // style={{
                //   textDecoration: "underline",
                //   // color: "blue",
                //   fontWeight: "bolder",
                // }}
                // to={`/dashboard/TransactionalReport/All`}
              >
                {cell?.row?.original?.filename}
              </div>
              <div className="my-2 fw-bold" style={{ color: "#959595" }}>
                {`(${cell?.row?.original?.uploadedBy})`}
              </div>
            </>
          );
        },
      },
      {
        Header: "Date",
        accessor: "fileUpload",
      },
      {
        Header: "Total Upload",
        accessor: "totalCount",
        Cell: (cell) => {
          return (
            <>{cell.row.original.totalCount?.toLocaleString("en-US")}</>
          );
        },
      },
      {
        Header: "Total Success",
        accessor: "successCount", // accessor is the "key" in the data
        Cell: (cell) => {
          return (
            <>{cell.row.original.successCount?.toLocaleString("en-US")}</>
          );
        },
      },
      {
        Header: "Allready Exist",
        accessor: "duplicateCount", // accessor is the "key" in the data
        Cell: (cell) => {
          return (
            <>{cell.row.original.duplicateCount?.toLocaleString("en-US")}</>
          );
        },
      },
      {
        Header: "Total Failure",
        accessor: "failureCount",
        Cell: (cell) => {
          return (
            <>{cell.row.original.failureCount?.toLocaleString("en-US")}</>
          );
        },
      },


      
      {
        Header: "Download",

        Cell: (cell) => {
          return (
            <>
              {cell?.row?.original?.fileStatus == 0 ?
               (
                <>
                  <Box
                    sx={{ display: "block", width: "100px" }}
                    className="mx-auto"
                  >
                    <CircularProgress
                      style={{ width: "31px", height: "31px" }}
                    />
                  </Box>
                </>
              ) :  (
                <>
                  <div className="">
                    <button
                      className="btn color_1 px-2"
                      type="button"
                      id=""
                      data-bs-toggle=""
                      aria-expanded="false"
                      onClick={() => {
                        downloadFile(cell);
                      }}
                    >
                      <FileDownloadIcon />
                    </button>
                  </div>
                </>
              ) 
           
              }
            </>
          );
        },
      },
      // {
      //   Header: "Status",
      //   accessor: "fileStatus",
      //   Cell: (cell) => (
      //     <div className="">
      //       <button
      //         className="btn color_1 p-0 "
      //         type="button"
      //         id="dropdownMenuButton1"
      //         aria-expanded="false"
      //       >
      //         {cell.row.original.fileStatus == 0 ? (
      //           <>
      //             <span class="badge bg-warning">Pending</span>
      //           </>
      //         ) : (
      //           <>
      //             <span class="badge bg-success ">Success</span>
      //           </>
      //         )}

      //       </button>
      //     </div>
      //   ),
      // },

      // {
      //   Header: "Download",
      //   accessor: "downloadUrl",
      //   Cell: (cell) => (
      //     <div className="">
      //       <button
      //         className="btn color_1 "
      //         type="button"
      //         id=""
      //         data-bs-toggle=""
      //         aria-expanded="false"
      //         onClick={() => {
      //           downloadFile(cell);
      //         }}
      //       >
      //         <FileDownloadIcon />
      //       </button>
      //     </div>
      //   ),
      // },
    ]: [
      {
        Header: "Id",
        accessor: "id",
        Cell: (cell) =>  <>{cell.row.index + 1 + TableStatus?.pageNo * TableStatus?.pageSize}</>
      },
      {
        Header: "Filename",
        accessor: "filename",
      },
      {
        Header: "Date",
        accessor: "fileUpload",
      },
      {
        Header: "Total Upload",
        accessor: "totalCount",
        Cell: (cell) => {
          return (
            <>{cell.row.original.totalCount?.toLocaleString("en-US")}</>
          );
        },
      },
      {
        Header: "Total Success",
        accessor: "successCount", // accessor is the "key" in the data
        Cell: (cell) => {
          return (
            <>{cell.row.original.successCount?.toLocaleString("en-US")}</>
          );
        },
      },
      {
        Header: "Allready Exist",
        accessor: "duplicateCount", // accessor is the "key" in the data
        Cell: (cell) => {
          return (
            <>{cell.row.original.duplicateCount?.toLocaleString("en-US")}</>
          );
        },
      },
      {
        Header: "Total Failure",
        accessor: "failureCount",
        Cell: (cell) => {
          return (
            <>{cell.row.original.failureCount?.toLocaleString("en-US")}</>
          );
        },
      },
      {
        Header: "Status",
        accessor: "fileStatus",
        Cell: (cell) => (
          <div className="">
            <button
              className="btn color_1 p-0 "
              type="button"
              id="dropdownMenuButton1"
              aria-expanded="false"
            >
              {/* {console.log("cell111", cell)} */}
              {cell.row.original.fileStatus == 0 ? (
                <>
                  <span class="badge bg-warning">Pending</span>
                </>
              ) : (
                <>
                  <span class="badge bg-success ">Success</span>
                </>
              )}

              {/* {/ <DeleteIcon /> /} */}
            </button>
          </div>
        ),
      },

      {
        Header: "Download",
        Footer: "Download",
        accessor: "downloadUrl",
        Cell: (cell) => (
          <div className="">
            <button
              className="btn color_1 "
              type="button"
              id=""
              data-bs-toggle=""
              aria-expanded="false"
              onClick={() => {
                downloadFile(cell);
              }}
            >
              <FileDownloadIcon />
            </button>
          </div>
        ),
      },
    ],
    [TableStatus]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );
  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const deletUser = () => {
    // console.log({ selectedFlatRows });
  };

  const changeOrder = () => {
    setColumnOrder(["id", "username", "action", "role", "email"]);
  };

  // ............................................................................................//
  async function AccountId() {
    // console.log("first");
    try {
      setHideSkeleton1(true);
      const result = await common_axios(
        // "http://192.168.167.66:5002/v1/get-rules"
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/v1/drools-rule/get/user/data`,
       
      );
      if (result.data.statusDescription.statusCode == 200) {
        setHideSkeleton1(false);
        let x = [
          {
            userId: "all",
            userName: "All",
          },
        ];
        let temp = [...x, ...result.data.accountId];
        // temp.push({
        //   userId: 0,
        //   userName: "All",
        // });
        setAccountIdValue(temp);
        // setAccountIdValue(result.data.accountId);
      } else {
        setHideSkeleton1(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusdescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      // setOpen(false);
      setHideSkeleton1(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }
  useEffect(() => {
    if (
      JSON.parse(localStorage.getItem("Sidebaritems")).name ==
      "ROLE_SUPER_ADMIN"
    ) {
      AccountId();
    }
  }, []);

  useEffect(() => {
    document.getElementById("fileName").value = "";
    setUserState([]);
  }, [resetValue]);


  // --------------------------------Blacklist calender------------------------------
 
  const onKeyDown = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    setValue(new Date());
  }, []);

  // ----------------------------------ENd calender------------------------------------

  return (
    <>
      <div>
        {/* <Button onClick={handleToggle}>Show backdrop</Button> */}
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
        >
          <Loader />
        </Backdrop>
      </div>

      <div className="card shadow-none border bg_blue mt-5">
        <span className="badge rounded-pill bg-primary mt-n3 ms-5">
          {/* Upload File */}
          Bulk File Upload
        </span>
        <div className="card-body text-lg-start text-center">
          <div class="row" id="bulk_file_upload">
            <div className="col-md-3">
              <div className=" align-items-center">
                <Button className="w-100"
                  variant="contained"
                  component="label"
                  style={{
                    backgroundColor: "white",
                    boxShadow: "none",
                    height: "40px",
                    border: "1px solid #d2d6da",
                    padding: "0px 0px 0px 0px",
                    margin: "0px -3px 0px 0px",
                  }}
                >
                  <input
                    id="fileName"
                    type="file"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    onChange={handleChange}
                    style={{ color: "#7b809a" }}
                  />
                </Button>
             
                <div className="d-inline-flex">
                  {/* <span className="ms-4">(Reference File)</span> */}

                  <a
                    // href={contactfile}
                    href={Blacklisting}
                    target="_blank"
                    download="Reference.xlsx"
                    className="text-info mt-2"
                  >
                    {/* .xlsx */}( Sample File Format )
                  </a>
                  {/* <span>
                        <ChooseFileExample />
                      </span> */}
                </div>
              </div>
            </div>
        

            {JSON.parse(localStorage.getItem("Sidebaritems")).name ==
            "ROLE_SUPER_ADMIN" ? (
              <>
                {hideSkeleton1 == true ? (
                  <>
                    <Box sx={{ width: 330 }}>
                      <Skeleton />
                      <Skeleton animation="wave" />
                      {/* <Skeleton animation={false} /> */}
                    </Box>
                  </>
                ) : (
                  <>
                    <div className="col-md-3">
                      {hideSkeleton1 == true ? (
                        <>
                          <Box sx={{ width: 150 }}>
                            <Skeleton />
                            <Skeleton animation="wave" />
                            {/* <Skeleton animation={false} /> */}
                          </Box>
                        </>
                      ) : (
                        <>
                          <div>
                            <Autocomplete
                              // disabled={MenuItemPhoneBook==undefined}
                              size="small"
                              fullWidth
                              value={userState}
                              onChange={(e, val) => {
                                setUserState(val);
                              }}
                              multiple
                              limitTags={2}
                              id="multiple-limit-tags"
                              getOptionDisabled={(option) =>
                                userState?.[0]
                                  ? userState?.[0]?.userName === "All"
                                    ? option.userName !== "All"
                                    : option.userName === "All"
                                  : null
                              }
                              options={accountidvalue}
                              getOptionLabel={(option) => option.userName}
                              // defaultValue={mappingArray}
                              renderInput={(params) => (
                                <TextField
                                  // required
                                  // disabled={mappingDisable}
                                  size="small"
                                  fullWidth
                                  {...params}
                                  label="User Name List"
                                  // placeholder="User Name List"
                                />
                              )}
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </>
                )}
                <div className="col-md-3" id="calendar_upto">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Stack spacing={3}>
                        <DesktopDatePicker
                          disablePast
                          label="Valid Upto"
                          value={value}
                          // minDate={startDate}

                          onChange={(newValue) => {
                            setValue(newValue.$d);
                          }}
                          renderInput={(params) => (
                            <TextField
                              onKeyDown={onKeyDown}
                              {...params}
                              helperText={"(Date time format mm/dd/yyyy"}
                            />
                          )}
                        />
                      </Stack>
                    </LocalizationProvider>
                  </div>
                <div className="col-md-3">
                  <button
                    // disabled={hide}
                    disabled={hide === true
                    || userState?.length == 0
                    || value == null
                    }

                    type="button"
                    className="btn dawnload_UP w_btn m-0 ms-3 btn_w8"
                    onClick={SubmitImage}
                  >
                    Upload
                    {/* <i class="material-icons opacity-10">file_upload</i> */}
                    {/* <FileUploadIcon style={{ fontSize: "17px" }} /> */}
                  </button>

                  <button
                    onClick={uploadreset}
                    type="button"
                    className="btn resetBtn_UP m-0 ms-2 w_btn btn_w8 btnReset"
                  >
                    Reset
                 
                    {/* <SettingsBackupRestoreRoundedIcon
                      style={{ fontSize: "17px" }}
                    /> */}
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className="col-md-3">
                  <TextField
                    required
                    disabled
                    className="w-100"
                    label="Name"
                    // name="name"
                    variant="outlined"
                    size="small"
                    value={localStorage.getItem("usernamedisplayed")}
                    type="text"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Tooltip
                            title="Name"
                            placement="top"
                            arrow
                            sx={{ color: "#85CBF2" }}
                          >
                            <InfoIcon />
                          </Tooltip>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                <div className="col-md-3" id="calendar_upto">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Stack spacing={3}>
                        <DesktopDatePicker
                          disablePast
                          label="Valid Upto"
                          value={value}
                          // minDate={startDate}

                          onChange={(newValue) => {
                            setValue(newValue.$d);
                          }}
                          renderInput={(params) => (
                            <TextField
                              onKeyDown={onKeyDown}
                              {...params}
                              helperText={"(Date time format mm/dd/yyyy"}
                            />
                          )}
                        />
                      </Stack>
                    </LocalizationProvider>
                  </div>
                <div className="col-md-3">
                  <button
                    // disabled={hide}
                    disabled={hide === true
                    || value == null
                    }
                    // disabled={hide === true || userState?.length == 0}
                    type="button"
                    className="btn dawnload_UP w_btn m-0 ms-3 btn_w8"
                    onClick={SubmitImage}
                  >
                    Upload
                    {/* <i class="material-icons opacity-10">file_upload</i> */}
                    {/* <FileUploadIcon style={{ fontSize: "17px" }} /> */}
                  </button>

                  <button
                    onClick={uploadreset}
                    type="button"
                    className="btn resetBtn_UP m-0 ms-2 w_btn btn_w8 btnReset"
                    // onClick={Reset}
                  >
                    Reset
                    {/* <i class="material-icons opacity-10 ">
                                settings_backup_restore
                              </i> */}
                    {/* <SettingsBackupRestoreRoundedIcon
                      style={{ fontSize: "17px" }}
                    /> */}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="card shadow-none border bg_blue mt-5">
        <span className="badge rounded-pill bg-primary mt-n3 ms-5 ">
          {/* Upload File List
           */}
          Bulk File Upload List
        </span>

        {data?.length > 0 ? (
          <>
            <div className="p-4">
              <div className="d-flex justify-content-between mt-3">
                <select
                  value={TableStatus.pageSize}
                  className="dropdown"
                  onChange={(e) => {
                    setPageSize(Number(e.target.value));
                    setTableStatus({
                      ...TableStatus,
                      pageSize: e.target.value,
                    });
                  }}
                >
                  {[10, 25, 50].map((value, i) => {
                    return (
                      <option
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton1"
                        value={value}
                        key={value}
                      >
                        Show {value}
                      </option>
                    );
                  })}
                </select>
                <Tooltip title="Refresh">
                  <button
                    type="submit"
                    className="btn bg-gradient-primary w_btn m-0 ms-3 me-3 search_1  "
                    // onClick={RefreshBtn}
                    onClick={() => RefreshBtn("Text to Copy")}
                  >
                    {/* <i class="material-icons opacity-10">refresh</i> */}
                    <RefreshIcon />
                  </button>
                </Tooltip>
              </div>
              {/* <div className="d-flex align-items-center">
               
                
              </div> */}
              <div>
                {selectedFlatRows.length > 0 && (
                  <button onClick={deletUser}>Delete Users</button>
                )}
              </div>

              <div class="table-responsive mt-3">
                <table
                  {...getTableProps()}
                  id="example"
                  className="table blacklisting_table table-striped table-bordered dataTable table-sm"
                  style={{ width: "100%" }}
                >
                  <thead>
                    {headerGroups.map((headerGroup) => (
                      <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column) => (
                          <th
                            {...column.getHeaderProps(
                              column.getSortByToggleProps()
                            )}
                            className="text-center width_2"
                          >
                            {column.render("Header")}
                            <span>
                              {column.isSorted
                                ? column.isSortedDesc
                                  ? "↑"
                                  : "↓"
                                : ""}
                            </span>
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  <tbody class='onhover_change' {...getTableBodyProps()}>
                    {page.map((row) => {
                      prepareRow(row);
                      return (
                        <tr {...row.getRowProps()}>
                          {row.cells.map((cell) => {
                            return (
                              <td
                                {...cell.getCellProps()}
                                // className="text-left"
                                // className={
                                //   (cell.column.Header == "ID" ||
                                //     cell.column.Header == "Date" ||
                                //     cell.column.Header == "Total Upload" ||
                                //     cell.column.Header == "Total Success" ||
                                //     cell.column.Header == "Total Failure"||
                                //     cell.column.Header == "Duplicate Count") &&
                                //   "text-end"
                                // }
                                className={
                                  cell.column.Header == "Id" ||
                                  cell.column.Header == "Total Upload" ||
                                  cell.column.Header == "Total Success" ||
                                  cell.column.Header == "Total Failure" ||
                                  cell.column.Header == "Allready Exist"
                                    ? "text-end"
                                    : cell.column.Header == "Status" ||
                                      cell.column.Header == "Action"
                                      ||
                                      cell.column.Header == "Download"
                                    ? "text-center"
                                    : "text-start"
                                }
                              >
                                <div>{cell.render("Cell")}</div>
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              <div className="d-flex justify-content-between">
                <div>
                  <span>
                    Page:
                    <strong>
                      {data1?.pageable?.pageNumber + 1} of {data1?.totalPages}
                    </strong>
                  </span>
                </div>



                <div className="prev_next d-flex align-items-center">
                <button
                      className="css-21ve8j css-r93niq-MuiButtonBase-root-MuiPaginationItem-root m-0"
                      type="button"
                      // style={{ background: "#2C97D4" }}
                      //  disabled={data1?.pageable?.pageNumber == 0}
                      onClick={() => {
                       
                        setTableStatus({
                          ...TableStatus,
                          pageNo:0,
                        });
                        setPaginationPage(1)
                      }}
                    >
                      First
                    </button>

                <Stack spacing={2}>
              <Pagination
                onChange={(event, value) => {
                  console.log("va--", value);
                  setTableStatus({
                    ...TableStatus,
                    pageNo: Number(value) - 1,
                  });
                  setPaginationPage(value);
                }}
                page={paginationPage}
                count={data1 ? data1?.totalPages : ""}
               
                variant="outlined"
                shape="rounded"
                
            color="primary"
              />
            </Stack>
            <button
                      className="css-21ve8j css-r93niq-MuiButtonBase-root-MuiPaginationItem-root ms-2"
                      type="button"
                      // style={{ background: "#2C97D4" }}
                      // disabled={
                      //   data1?.totalPages == data1?.pageable?.pageNumber + 1
                      //  }
                      onClick={() => {
                        // alert("gg")
                        setTableStatus({
                          ...TableStatus,
                          pageNo:data1?.totalPages -1 ,
                        });
                        setPaginationPage(data1?.totalPages)

                      }}
                    >
                      Last
                    </button>
                
              </div>


                {/* <div className="btn_n800">
                  <button
                    className="btn btn_primary "
                    type="button"
                    style={{ background: "#2C97D4" }}
                    disabled={data1?.pageable?.pageNumber == 0}
                    onClick={() => {
                      setTableStatus({
                        ...TableStatus,
                        pageNo: TableStatus.pageNo - 1,
                      });
                    }}
                  >
                    Prev
                  </button>

                  <button
                    className="btn btn_primary ms-2"
                    type="button"
                    style={{ background: "#2C97D4" }}
                    disabled={
                      data1?.totalPages == data1?.pageable?.pageNumber + 1
                    }
                    onClick={() => {
                      setTableStatus({
                        ...TableStatus,
                        pageNo: TableStatus.pageNo + 1,
                      });
                    }}
                  >
                    Next
                  </button>
                  
                </div> */}
              </div>
            </div>
          </>
        ) : (
          <>
            {/* <div className="text-center">
              {data?.length == 0 && open ? null : (
                <div className="text-center">
                  <h5>No Record Found..!! Found</h5>
                </div>
              )}
            </div> */}
            <div className="text-center mt-4">
                              {data?.length == 0 &&
                              open == true ? null : data?.length == 0 &&
                                open == undefined ? null : (
                                <div className="text-center">
                                  <h5>No Record Found..!!</h5>
                                </div>
                              )}
                            </div>
          </>
        )}
      </div>
    </>
  );
};

export default BulkUpload;
